'use strict';

var _ = require('underscore'),
    UserStore = require('../stores/UserStore'),
    AnalyticsClient = require('./AnalyticsClient'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    parseHostname = require('./parseHostname'),
    ga = require('ga'),
    config = require('config');

var backendUrl = config.statsBaseUrl;
if (!backendUrl) {
  throw new Error('You forgot to pass statsBaseUrl as config parameter.');
}

var Analytics = {
  start: function () {
    var options = {
      backendUrl: backendUrl,
      fingerprintKey: 'stampsy-bigdata-fingerprint',
      sessionKey: 'stampsy-bigdata-session'
    };

    if (UserStore.isAuthenticated()) {
      options.userId = UserStore.getMe().id;
    }

    AnalyticsClient.initialize(options);

    var location = document.location,
        referrer = document.referrer;

    if (location.hostname !== parseHostname(referrer)) {
      _.delay(this.trackExternalVisit, 1000);
    }
  },

  trackExternalVisit: function () {
    Analytics.trackEvent(AnalyticsEvents.STAMPSY_VISIT, {
      referrer: document.referrer
    });
  },

  trackEvent: function (name, params) {
    if (!name) {
      console.warn('trackEvent() called with empty name.');
    }

    var me = UserStore.getMe();
    if (me && me.isStaff) {
      return;
    }

    params = params || {};
    AnalyticsClient.trackEvent(name, params);
  },

  trackGAEvent: function (action, label, value) {
    if (!action) {
      console.warn('trackGAEvent() called with empty action.');
    }

    var me = UserStore.getMe();
    if (me && me.isStaff) {
      return;
    }

    ga('send', 'event', 'web', action, label, value);
  },

  trackPageView: function (currentPath, activeRoutes, activeParams) {
    var me = UserStore.getMe();
    if (me && me.isStaff) {
      return;
    }

    var canonicalPath = this.getCanonicalPath(currentPath, activeRoutes, activeParams);
    ga('send', 'pageview', canonicalPath);
  },

  getCanonicalPath: function(path, activeRoutes, activeParams) {
    var deepestRoute = _.last(activeRoutes),
        { stampId } = activeParams;

    if (!deepestRoute) {
      return path;
    }

    if (!deepestRoute.name.endsWith('Stamp') || !stampId) {
      return path;
    }

    return '/stamp/' + stampId;
  }
};

module.exports = Analytics;



/** WEBPACK FOOTER **
 ** ./utils/Analytics.js
 **/